import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import axiosInstance from "../../../Services/axios";

import style from '../../../../scss/components/form.module.scss';

const AddUserBadge = ({entity, name, onChange}) => {

    const [badges, setBadges] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedBadges, setSelectedBadges] = useState(
        entity.badges ? entity.badges.map(badge => badge.type) : []
    );

    useEffect(() => {
        axiosInstance.get('/admin/enum/badges')
            .then(response => {
                setBadges(response.data);
                setLoading(false);
            })
            .catch(() => {
                alert("Error fetching badges:");
                setLoading(false);
            });
    }, []);

    const handleCheckboxChange = (badgeValue) => {
        const newValues = selectedBadges.includes(badgeValue)
            ? selectedBadges.filter(value => value !== badgeValue)
            : [...selectedBadges, badgeValue];

        setSelectedBadges(newValues);
        if (onChange) {
            onChange({
                [name]: newValues
            });
        }
    };

    if (loading) {
        return <div>Loading badges...</div>;
    }

    return (
        <div className="mt-20">
            <label className={`${style.label} mb-4`}>User Badges</label>
            <div className="flex flex-col gap-3">
                {badges.map((badge) => (
                    <div key={badge.value} className="flex items-center">
                        <input
                            name={name}
                            id={`badge-${badge.value}`}
                            type="checkbox"
                            value={badge.value}
                            checked={selectedBadges.includes(badge.value)}
                            onChange={() => handleCheckboxChange(badge.value)}
                            className="mr-3 w-6 h-6 cursor-pointer"
                        />
                        <label htmlFor={`badge-${badge.value}`}
                               className="text-2xl font-normal cursor-pointer">
                            {badge.label}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default AddUserBadge;

AddUserBadge.propTypes = {
    entity: PropTypes.object.isRequired,
    name: PropTypes.string,
    onChange: PropTypes.func
}
